import { render, staticRenderFns } from "./SendEmailForgotPasswordForm.vue?vue&type=template&id=993a60a6&scoped=true&"
import script from "./SendEmailForgotPasswordForm.vue?vue&type=script&lang=js&"
export * from "./SendEmailForgotPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993a60a6",
  null
  
)

export default component.exports